import React, { useEffect, useRef, useState } from "react";
import { withTranslation } from "react-i18next";
import { isEmpty } from "lodash";
import { request } from "../../../../utils/Request";
import UrlHelper from "js-url-helper";
import InvoiceList from "./partials/InvoiceList";
import qs from "qs";
import { Route, Routes } from "react-router-dom";
import { Toast } from "primereact/toast";
import { getFromStorage, setToStorage } from "../../../../utils/Helper";

const DEFAULT_DROPDOWNS = {
    alpSpotLoads: [],
};

const url = new UrlHelper();

const ArchivedInvoice = (props: any) => {
    const { t } = props;
    const toast = useRef(null);
    const [dropdowns, setDropdowns] = useState<any>(null);
    const [moduleState, setModuleState] = useState<any>({
        page: 1,
        per_page: 20,
        search: null,
        initialized: false,
        sort_field: null,
        sort_order: null,
    });

    const getDropdowns = async () => {
        try {
            const response = await request({
                url: '/suppliers/archived/invoices/create',
                params: {
                    type: 'list',
                }
            });
            const { data } = response.data;
            setDropdowns({
                clients: data.clients,
                recipientTypes: data.recipient_types,
                bankAccounts: data.bank_accounts,
                currencies: data.currencies,
                statuses: data.statuses,
                legalEntities: data.legal_entities,
                paymentMethods: data.payment_methods,
            });
        } catch (e) {
            setDropdowns(DEFAULT_DROPDOWNS);
        } finally {
            const prevUrl = qs.parse(url.getSearchParam().prev_url ?? "");
            const fromStorage: any = getFromStorage('supplierBrandModuleState');
            const defaultState = {
                page: !isEmpty(prevUrl.page) ? url.getSearchParam().page : 1,
                per_page: !isEmpty(prevUrl.per_page) ? url.getSearchParam().per_page : 20,
                search: !isEmpty(prevUrl.search) ? url.getSearchParam().search : null,
                initialized: true,
                sort_field: null,
                sort_order: null,
                ...( !isEmpty(fromStorage) ? JSON.parse(fromStorage) : {} )
                // filters: !isEmpty(prevUrl.filters) ? url.getSearchParam().filters : qs.stringify({
                //     statuses: ['produced']
                // }),
            };

            setModuleState(defaultState);
            setToStorage('supplierBrandModuleState', JSON.stringify(defaultState));
        }
    };

    useEffect(() => {
        document.title = t("invoices");

        async function init() {
            await getDropdowns();
        }

        init();
    }, []);

    const toastify = (message: any, color: string = 'info', summary: any = null) => {
        if ( toast && toast.current ) {
            // @ts-ignore
            toast.current.show({ severity: color, summary: summary, detail: message });
        }
    };

    const setQuery = (value: any) => {
        setToStorage('supplierBrandModuleState', JSON.stringify(value));
        setModuleState(value);
    };

    return (
        <div className={ "module-container" }>
            <Toast ref={ toast } />
            <div className="layout-content">
                { ( moduleState && moduleState.initialized ) ?
                    <React.Fragment>
                        <Routes>
                            <Route path={ "/" } element={
                                <InvoiceList
                                    moduleState={ moduleState }
                                    dropdowns={ dropdowns }
                                    toastify={ toastify }
                                    setQuery={ setQuery }
                                /> } />
                        </Routes>
                    </React.Fragment>
                    : <h6>{ t('loading') }</h6> }
            </div>
        </div>
    );
};

// Brand.propTypes = {
//     t: PropTypes.any,
// };

export default withTranslation()(ArchivedInvoice);
